import * as API from "../../api";
import * as ActionTypes from "../action-types";
import { message } from "antd";
import { setLoadingEmployee, unsetLoadingEmployee } from "./style";

export const get_all_employee_request = () => (dispatch) => {
  dispatch(setLoadingEmployee());
  API.getAllEmployee()
    .then((info) => {
      const { status, msg, employees } = info;
      if (status === 200) {
        dispatch(get_all_employee_success(employees));
        message.success("Successfully get the employee data");
      } else {
        message.warning(msg);
      }
    })
    .finally(() => {
      dispatch(unsetLoadingEmployee());
    });
};

const get_all_employee_success = (employee) => {
  return {
    type: ActionTypes.EMPLOYEE_GET_ALL,
    employee,
  };
};

export const get_all_employee_by_coid_request = (coid) => (dispatch) => {
  dispatch(setLoadingEmployee());
  API.getAllEmployeeInfoByCoid({coid})
    .then((info) => {
      const { status, msg, employees } = info;
      if (status === 200) {
        dispatch(get_all_employee_by_coid_success(employees));
        message.success("Successfully get the employee data");
      } else {
        message.warning(msg);
      }
    })
    .finally(() => {
      dispatch(unsetLoadingEmployee());
    });
};

const get_all_employee_by_coid_success = (employee) => {
  return {
    type: ActionTypes.EMPLOYEE_GET_ALL_BY_COID,
    employee,
  };
};


export const create_employee = (items, role, cb) => (dispatch) => {
  dispatch(setLoadingEmployee());
  
  API.createEmployee(items)
    .then((info) => {
      const { status, employee, msg, remarkCount } = info;
      if (status === 200) {
        dispatch(create_employee_success(employee, role));
        dispatch(update_remarkcount_employee_success({refid: employee.memid, remarkCount}))
        message.success("Create Employee Successfully");
      } else {
        message.warning(msg);
      }
    })
    .finally(() => {
      cb();
      dispatch(unsetLoadingEmployee());
    });
};

const create_employee_success = (employee, role) => {
  return {
    type: ActionTypes.CREATE_EMPLOYEE,
    employee,
    role
  };
};

export const update_employee_request = (items, role, cb) => (dispatch) => {
  dispatch(setLoadingEmployee());
  API.updateEmployee(items)
    .then((data) => {
      const { status, employee, msg, remarkCount } = data;
      if (status === 200) {
        dispatch(update_employee_success(employee, role));
        dispatch(update_remarkcount_employee_success({refid: employee.memid, remarkCount}))
        message.success("Update Employee successfully");
      } else {
        message.warning(msg);
      }
    })
    .finally(() => {
      cb();
      dispatch(unsetLoadingEmployee());
    });
};

const update_employee_success = (employee, role) => {
  return {
    type: ActionTypes.UPDATE_EMPLOYEE,
    employee,
    role
  };
};

export const validate_bulk_upload_employee_request = (items, cb) => (dispatch) => {
  API.validateBulkEmployee(items)
    .then((info) => {
      const { status, msg, successEmployees, failedEmployees } = info;
      if (status === 200) {
        message.success(msg)
        cb({status: 200, dataSuccess: successEmployees, dataFailed: failedEmployees})
      } else {
        message.warning(msg);
        cb({status: status, data: failedEmployees})
      }
    })
};

export const bulk_upload_employee_request = (items, cb) => (dispatch) => {
  dispatch(setLoadingEmployee());
  API.bulkUploadEmployee(items)
    .then((info) => {
      const { status, msg, employees, successEmployees, failedEmployees } = info;
      if (status === 200) {
        dispatch(bulk_upload_employee_success(employees));
        message.success(msg);
        cb({status: 200})
      } else if(status === 207){
          if(successEmployees?.length){
            dispatch(bulk_upload_employee_success(successEmployees));
          } 
          message.warning(msg);
          cb({status: 207, data: failedEmployees})
      } else {
        message.warning(msg);
      }
    })
};

const bulk_upload_employee_success = (employee) => {
  return {
    type: ActionTypes.BULK_UPLOAD_EMPLOYEE,
    employee
  };
};

export const update_remarkcount_employee_success = (remark) => {
  return {
    type: ActionTypes.UPDATE_REMARKCOUNT_EMPLOYEE,
    remark,
  };
};

